import { useMemo } from "react";

import { External } from "components/icons/generated";

import useStackListAnalytics from "../useStackListAnalytics";

const useGoToRunAction = (runUrl: string | undefined) => {
  const trackAnalytics = useStackListAnalytics();

  return useMemo(() => {
    if (!runUrl) {
      return undefined;
    }

    return {
      icon: External,
      title: "Go to run",
      href: runUrl,
      onPress: () => {
        trackAnalytics("Go to run clicked");
      },
    };
  }, [runUrl, trackAnalytics]);
};

export default useGoToRunAction;
